// tslint:disable:no-console
import { HubConnection } from '@aspnet/signalr'
import { DispatchProp } from 'modules/store'
import { Component, ReactNode } from 'react'
import { connect } from 'react-redux'

import { Operations, operationToActionMap, operationToInitActionMap } from './operation-action-map'
import { getData } from './store'

import { isBlank, isFunction, isPresent } from '../../app/shared'
import { State } from '../../app/store'

type RenderProp = (data: object) => ReactNode

export type PublicProps = {
  children: RenderProp
  operation: Operations
  initParams?: any
}

type OwnProps = {
  connection: HubConnection | null
}

type StateToProps = {
  data: any
}

const mapStateToProps = (state: State, ownProps: PublicProps) => ({
  data: getData(state, ownProps.operation),
})

const enhance = connect(mapStateToProps)

type Props = PublicProps & OwnProps & DispatchProp & StateToProps

// main storage for operations that will be registered in this component
const registeredOperations: string[] = []

class Connection extends Component<Props> {
  render() {
    const { data, children } = this.props

    if (!isFunction(children)) {
      throw new Error('Children has to be a function [ (data) => ReactNode ]!')
    }

    return children(data)
  }

  componentDidMount() {
    const { connection, dispatch, initParams, operation: op } = this.props

    if (isBlank(connection)) return

    // store 'registration' to list
    // ie. defense against multiple subscription to one operation (multiple components on one page)
    if (!isRegistered(op)) {
      connection.on(op, (data: any) => {
        dispatch(new operationToActionMap[op](data))
      })

      registeredOperations.push(op)

      // automagic
      if (isPresent(operationToInitActionMap[op])) {
        dispatch(new operationToInitActionMap[op](initParams))
      }

      console.log(`Registering operation [${op}]`)
    }
  }

  componentWillUnmount() {
    const { connection, operation: op } = this.props

    if (isBlank(connection)) return

    connection.off(op)

    if (isRegistered(op)) {
      registeredOperations.splice(registeredOperations.indexOf(op), 1)

      console.log(`Unregistering operation [${op}]`)
      console.log(registeredOperations)
    }
  }
}

const isRegistered = (operation: string) => registeredOperations.some((op) => op === operation)

export default enhance(Connection)



// WEBPACK FOOTER //
// ./src/modules/signal-r/connection.tsx